import { useState } from 'react'
import { Modal, Formatter } from 'shared'
import { SquareMarketplacesApi } from 'api';

const StoreItemReservationBlock = ({ park }) => {
  // State
  const [state, setState] = useState({
    cartItems: (park.store_items || []).map(item => ({ ...item, quantity: 0 })),
    failed: false, done: false, progress: false, succeeded: false
  })

  // Custom Methods
  const didMovedToCardSettings = () => {
    Modal.current.hide();
  }
  const inc = (itemId, count) => {
    const cartItems = state.cartItems.map(item =>
      item.id === itemId ? { ...item, quantity: Math.max(0, item.quantity + count) } : item
    );
    setState({ ...state, cartItems });
  }

  const calculateTotalAmount = () => {
    return state.cartItems.reduce((total, item) => total + (item.price * item.quantity), 0);
  }

  const renderCardRequired = () => {
    return <div className="text-center">
      <p>You need to set up a credit card to perform payments.</p>
      <Link to="/settings/payment" onClick={didMovedToCardSettings}>Add a Credit Card</Link>
    </div>
  }

  const pay = async () => {
    setState({ ...state, progress: true, failed: false, done: false, succeeded: false });

    const cartItems = state.cartItems
      .filter(item => item.quantity > 0)
      .map(item => ({
        id: item.id,
        square_id: item.square_id,
        price: item.price,
        quantity: item.quantity,
      }));

    const paymentParams = {
      cart_items: cartItems,
      store_id: park.id,
      web_request: true
    };

    try {
      const result = await SquareMarketplacesApi.perform(paymentParams);
      if (result.success) {
        setState({ ...state,
          cartItems: (park.store_items || []).map(item => ({ ...item, quantity: 0 })),
          done: true, progress: false, succeeded: true
        });
      } else {
        setState({ ...state, done: false, progress: false, failed: true, error: result.error_message });
        App.state.setError({ message: "Something Went Wrong", error: { message: "Error Message" } })
      }
    } catch (xhr) {
      setState({ ...state, done: false, progress: false, failed: true, error: xhr.message });
      App.state.setError({ message: xhr.responseJSON.message || "Payment failed", error: { message: "Error Message" } })
    }
  }

  const { progress, done, succeeded, failed, error } = state;
  const totalAmount = calculateTotalAmount();

  // Renderd

  if (_.isEmpty(state.cartItems)) return null;

  return <>
    {
      !application.user.hasCard ? renderCardRequired() : <>
        <div className="park-item-selector">
          <h5 className="park_item_selector__title subpanel-title">Store Items</h5>
          <div className="park-item-selector__list">
            <table className="items-table table table-sm table-borderless table-font-sm">
              <tbody>
              { state.cartItems.map(cartItem => (
                <tr key={cartItem.id}>
                  <td className="item-name">{cartItem.name}</td>
                  <td>{Formatter.amountFromCents(cartItem.price, { free: true })}</td>
                  <td className="text-right">
                    <button type='button' className='btn btn-outline-primary btn-sm ticket-btn' onClick={() => inc(cartItem.id, -1)}>–</button>
                    <span className='counter mx-2'>{cartItem.quantity}</span>
                    <button type='button' className='btn btn-outline-primary btn-sm ticket-btn' onClick={() => inc(cartItem.id, +1)}>+</button>
                  </td>
                </tr>
              ))}
              </tbody>
            </table>
          </div>
        </div>
        { progress && <p className="alert alert-info text-center">Processing...</p>}
        { succeeded && <p className="alert alert-info text-center">Payment completed. Thank you.</p>
        }
        {/* { failed && !progress && <p className="alert alert-danger text-center">Payment failed. {error}</p> } */}
        { !progress &&
          <p className="text-center"> <button className='btn btn-primary' type="button" onClick={pay}> Pay { Formatter.amountFromCents(totalAmount) } </button></p>
        }
      </>
    }
  </>
}

export default StoreItemReservationBlock
